<template>
  <div id="aha-gpt-touch-point" class="aha-gpt-touch-point relative">
    <div class="flex items-center justify-center">
      <aha-icon name="chatGPT" />
      <span class="text-xs pl-1">
        {{ $i18nPresenter.t('Already using ChatGPT? Try') }}
        <a
          class="text-link--primary underline font-medium"
          name="ai-panel-aha-gpt-touch-point"
          v-aha-emit-action
          @click="openAhaSlidesGPT"
        >
          AhaSlides GPT
        </a>
      </span>
      <aha-icon
        name="open-new-window"
        class="text-base-50"
        width="18"
        height="18"
        viewBox="-4 -4 32 32"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AhaSlidesGPTTouchPoint',

  props: {
    ahaGPTUrl: {
      type: String,
      required: true,
    },
  },

  methods: {
    openAhaSlidesGPT() {
      window.open(this.ahaGPTUrl, 'AhaSlidesGPT')
    },
  },
}
</script>
